import React, { useCallback, useEffect, useState } from 'react'
import { useApp_image_listQuery } from '../store/reactapiApi';
import {  Form, App,Modal, QRCode, Image, Space} from 'antd'
import { QrcodeOutlined,} from '@ant-design/icons';
function Uploadwx(props) {
    const {message} = App.useApp()
    const [open, setOpen] = useState(false);
    const [wxPic, setWxPic] = useState([]);
    const [uploadToken, setUploadToken] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const generateUploadToken = useCallback(async () => {
        try {
            const res = await fetch('/api/reactApi/app_upload_image_token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await res.json();
            
            if (data.Result.success) {
                setUploadToken(data.Result.token);
                const uploadUrl = `https://goldfish.bnsrj.com/UploadH5?token=${data.Result.token}`;
                setQrCodeUrl(uploadUrl);
            } else {
                message.error('生成上传token失败');
            }
        } catch (error) {
            message.error('网络错误，请重试');
        }
    }, [message]);
    const handleOpenModal = useCallback(() => {
        setOpen(true);
        generateUploadToken();
    }, [generateUploadToken]);

    // Get mobile uploaded images
    const {data, isSuccess} = useApp_image_listQuery(
        {itk_token: uploadToken},
        {skip: !uploadToken, refetchOnMountOrArgChange: true,pollingInterval:3000}
    );
    useEffect(() => {
        if(isSuccess && data.Status==='success'){
            if(data.Result.itk_image){
                setWxPic(data.Result.itk_image) 
                props.fileStr(data.Result.itk_image)               
                setOpen(false);
            }
        }
    },[data,isSuccess,props])
    return (
        <>
            <Form.Item label='手机传图'>
                {wxPic.length>1 ? <Space>{wxPic.map((item) => <Image src={`/api/assets/images/application/${item}`} alt='' width={40} height={40}/>)}</Space>:<a onClick={handleOpenModal}><QrcodeOutlined /> 扫码上传</a>}
            </Form.Item>
            <Modal
                title="手机传图"
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                width={350}
                centered
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    {qrCodeUrl ? (
                        <>
                            <QRCode
                                value={qrCodeUrl} 
                                size={200}
                                style={{ marginBottom: 16 }}
                            />
                            <p>用手机微信扫描二维码上传图片</p>
                        </>
                    ) : (
                        <p>正在生成上传二维码...</p>
                    )}
                </div>
            </Modal>
        </>  
    )
}

export default Uploadwx